#import "./flexibleSectionsBigAccordionItem.graphql"

fragment flexibleBigAccordion on flexibleSections_bigAccordion_BlockType {
    __typename
    children {
        __typename
        ... flexibleSectionsBigAccordionItem
    }
}
